import { FinancialStatus } from 'models/Order';

export enum PackageProviderName {
    FOXPOST = 'foxpost',
    MPL_DELIVERY = 'mpl_delivery',
    MPL_PACKAGE_POINT = 'mpl_package_point',
    MPL_MOL = 'mpl_mol',
    MPL_COOP = 'mpl_coop',
    MPL_MEDIAMARKT = 'mpl_mediamarkt',
    MPL_OFFICE = 'mpl_office',
    GLS = 'gls',
    GLS_GLOBAL = 'gls_global',
    PACKETA = 'packeta',
    DPD = 'dpd',
    SPRINTER = 'sprinter',
    TOURMIX = 'tourmix',
    FAN_COURIER = 'fan_courier',
    FAN_COURIER_INTERNATIONAL = 'fan_courier_international',
    BRING = 'bring',
    SAMEDAY = 'sameday',
    INPOST = 'inpost',
    POSTNORD = 'postnord',
    POSTASK = 'slovensk_po_ta',
    BPOST = 'bpost',
    CORREOS = 'correos',
    OMNIVA = 'omniva',
    CARGUS = 'cargus',
    // KVIKK = 'kvikk',

    // Underlying carriers offered through the Kvikk aggregator (not selectable as standalone providers).
    KVIKK_GLS = 'kvikk_gls',
    KVIKK_DPD = 'kvikk_dpd',
    KVIKK_PACKETA = 'kvikk_packeta',
    KVIKK_MPL = 'kvikk_mpl',
    // KVIKK_ALZABOX = 'kvikk_alzabox',
    // KVIKK_PARCEL_SHOP = 'kvikk_parcel_shop',
    // KVIKK_LOCKER = 'kvikk_locker',
    // KVIKK_SHOP = 'kvikk_shop',
    KVIKK_FOXPOST = 'kvikk_foxpost',
    // KVIKK_ZBOX = 'kvikk_zbox',
    // KVIKK_ZPONT = 'kvikk_zpont',
    // KVIKK_AUTOMATA = 'kvikk_automata',
    // KVIKK_POSTA = 'kvikk_posta',
    // KVIKK_POSTA_PONT = 'kvikk_posta_pont',
}

export const AVAILABLE_PROVIDERS: PackageProviderName[] = [
    PackageProviderName.MPL_PACKAGE_POINT,
    PackageProviderName.FOXPOST,
    PackageProviderName.GLS,
    PackageProviderName.GLS_GLOBAL,
    PackageProviderName.PACKETA,
    PackageProviderName.DPD,
    PackageProviderName.TOURMIX,
    PackageProviderName.FAN_COURIER,
    PackageProviderName.FAN_COURIER_INTERNATIONAL,
    PackageProviderName.BRING,
    PackageProviderName.SAMEDAY,
    PackageProviderName.INPOST,
    PackageProviderName.POSTNORD,
    PackageProviderName.POSTASK,
    PackageProviderName.BPOST,
    PackageProviderName.CORREOS,
    PackageProviderName.OMNIVA,
    PackageProviderName.CARGUS,
    // PackageProviderName.KVIKK,
];

export enum Languages {
    english = 'english',
    hungarian = 'hungarian',
    romanian = 'romanian',
    german = 'german',
    spanish = 'spanish',
}

export enum SettingKey {
    default_language = 'default_language',
    foxpost_api_keys = 'foxpost_api_keys',
    mpl_api_keys = 'mpl_api_keys',
    gls_api_keys = 'gls_api_keys',
    packeta_api_keys = 'packeta_api_keys',
    dpd_api_keys = 'dpd_api_keys',
    tourmix_api_keys = 'tourmix_api_keys',
    dpd_package_weight = 'dpd_package_weight',
    zones_and_providers = 'zones_and_providers',
    shipping_methods = 'shipping_methods',
    mpl_package_size = 'mpl_package_size',
    mpl_package_weight = 'mpl_package_weight',
    mpl_label_type = 'mpl_label_type',
    mpl_delivery_time_mode = 'mpl_delivery_time_mode',
    mpl_package_sending_mode = 'mpl_package_sending_mode',
    foxpost_label_type = 'foxpost_label_type',
    foxpost_packeta_label_type = 'foxpost_packeta_label_type',
    foxpost_package_size = 'foxpost_package_size',
    gls_label_type = 'gls_label_type',
    packeta_label_type = 'packeta_label_type',
    dpd_label_type = 'dpd_label_type',
    sprinter_label_type = 'sprinter_label_type',
    sender_details = 'sender_details',
    sender_details_extra_mpl = 'sender_details_extra_mpl',
    map_design = 'map_design',
    cart_button_design = 'cart_button_design',
    home_delivery = 'home_delivery',
    cash_onelivery = 'cod',
    payment_method = 'payment_method',
    provider_to_country = 'provider_to_country',
    integration_mode = 'integration_mode',
    app_activated = 'app_activated',
    map_translations = 'map_translations',
    selected_languages = 'selected_languages',
    enabled_shipping_types = 'enabled_shipping_types',
    checkout_settings = 'checkout_settings',

    test_api_keys_mpl = 'test_api_keys_mpl',
    test_api_keys_foxpost = 'test_api_keys_foxpost',
    test_api_keys_gls = 'test_api_keys_gls',
    test_api_keys_packeta = 'test_api_keys_packeta',
    test_api_keys_sprinter = 'test_api_keys_sprinter',
    test_api_keys_tourmix = 'test_api_keys_tourmix',

    use_test_api_mpl = 'use_test_api_mpl',
    use_test_api_foxpost = 'use_test_api_foxpost',
    use_test_api_gls = 'use_test_api_gls',
    use_test_api_packeta = 'use_test_api_packeta',
    use_test_api_sprinter = 'use_test_api_sprinter',
    use_test_api_tourmix = 'use_test_api_tourmix',
    mapped_payment_methods = 'mapped_payment_methods',

    mpl_order_send_mode = 'mpl_order_send_mode',
    gls_order_send_mode = 'gls_order_send_mode',
    packeta_order_send_mode = 'packeta_order_send_mode',
    foxpost_order_send_mode = 'foxpost_order_send_mode',
    dpd_order_send_mode = 'dpd_order_send_mode',
    tourmix_order_send_mode = 'tourmix_order_send_mode',

    mpl_third_party_fulfillment = 'mpl_third_party_fulfillment',
    gls_third_party_fulfillment = 'gls_third_party_fulfillment',
    packeta_third_party_fulfillment = 'packeta_third_party_fulfillment',
    foxpost_third_party_fulfillment = 'foxpost_third_party_fulfillment',
    dpd_third_party_fulfillment = 'dpd_third_party_fulfillment',
    tourmix_third_party_fulfillment = 'tourmix_third_party_fulfillment',

    gls_customer_note = 'gls_order_customer_note_enabled',
    mpl_customer_note = 'mpl_order_customer_note_enabled',
    foxpost_customer_note = 'foxpost_order_customer_note_enabled',
    sprinter_customer_note = 'sprinter_order_customer_note_enabled',
    packeta_customer_note = 'packeta_order_customer_note_enabled',
    dpd_customer_note = 'dpd_order_customer_note_enabled',

    gls_bulk_print_pdf = 'gls_bulk_print_pdf',
    mpl_bulk_print_pdf = 'mpl_bulk_print_pdf',
    foxpost_bulk_print_pdf = 'foxpost_bulk_print_pdf',
    sprinter_bulk_print_pdf = 'sprinter_bulk_print_pdf',
    packeta_bulk_print_pdf = 'packeta_bulk_print_pdf',
    dpd_bulk_print_pdf = 'dpd_bulk_print_pdf',
    tourmix_bulk_print_pdf = 'tourmix_bulk_print_pdf',

    dpd_sms_notification = 'dpd_sms_notification',

    rates_to_payment_methods = 'rates_to_payment_methods',

    gls_extra_package_services = 'gls_extra_package_services',

    foxpost_order_number_on_label = 'foxpost_order_number_on_label',

    order_reference_gls = 'order_reference_gls',

    mpl_value_insurance = 'mpl_value_insurance',

    gls_auto_fulfill = 'gls_auto_fulfill',
    tourmix_auto_fulfill = 'tourmix_auto_fulfill',
    mpl_auto_fulfill = 'mpl_auto_fulfill',
    foxpost_auto_fulfill = 'foxpost_auto_fulfill',
    dpd_auto_fulfill = 'dpd_auto_fulfill',
    packeta_auto_fulfill = 'packeta_auto_fulfill',
}

export enum WizardStepName {
    choose_service_provider = 'choose_service_provider',
    shipping_zone_rate = 'shipping_zone_rate',
    integration_mode_step = 'integration_mode_step',
    summary = 'summary',
    app_extensions = 'app_extensions',
}

export const financialStatuses: FinancialStatus[] = [
    'pending',
    'authorized',
    'partially_paid',
    'paid',
    'partially_refunded',
    'refunded',
    'voided',
];

export const noPickupPointProviders: PackageProviderName[] = [PackageProviderName.TOURMIX];

export const LEGACY_PARCEL_CREATE_PROVIDERS = [
    PackageProviderName.MPL_PACKAGE_POINT,
    PackageProviderName.FOXPOST,
    PackageProviderName.PACKETA,
    PackageProviderName.TOURMIX,
];
